import { Component, Inject, OnInit } from '@angular/core';
import { CommonsSessionStorageService, downgradeToAJSComponent } from 'ib-web-commons/utils';
import { GiftCardsPaymentService } from '../../services/ib-gift-cards-payments/ib-gift-cards-payments-service';
import { GiftCardRouterConstants } from '@core/routing/ib-gift-cards-router-constants';
import { GiftCardsAppConstant } from '@src/ib-gift-cards-constants';
import { RedirectionLandingService } from '@core/services/ib-gift-cards-redirection-service';
import { IbGiftCardsPaymentsService } from './ib-gift-cards-payments.service';
import { ReactComponentData } from '@src/app/core/models/generic-models/generic-models';
import angular from 'angular';
import { Summary, SummaryProps } from 'commercial-management--ancillaries--web-components-design--library/ancillaries-web-components';
import { AJSGiftCardsDatalayerService, GiftCardsDatalayerServiceType } from '@shared/services/upgrades/ib-gift-cards-datalayer-bridge-service';
import { GiftCardsDatalayerService } from '@core/services/ib-gift-cards-datalayer-service';


@Component({
    selector: 'ib-gc-payments-component',
    templateUrl: './ib-gift-cards-payments.component.html',
    styleUrls: ['./ib-gift-cards-payments.component.scss']
})

export class IbGiftCardsPaymentsComponent implements OnInit {
    public contextId:string;
    private paymentComponent;
    private currency: CurrencyResponse;
    public showComponent = false;

    public summaryComponent: ReactComponentData<SummaryProps> = {
        component: Summary,
        props: {} as SummaryProps
    };

    constructor (
        private giftCardsPaymentService: GiftCardsPaymentService,
        private commonsSessionStorageService: CommonsSessionStorageService,
        private IbGiftCardsPaymentsService: IbGiftCardsPaymentsService,
        @Inject('CommonsModalService') private commonsModalService: CommonsModalService,
        @Inject('RedirectionLandingService') private redirectionLandingService: RedirectionLandingService,
        @Inject('localStorageService') private localStorageService: angular.local.storage.ILocalStorageService,
        @Inject(AJSGiftCardsDatalayerService) private giftCardsDatalayerService: GiftCardsDatalayerServiceType
    ) {
    }

    async ngOnInit (): Promise<void> {
        this.showWaitingModal();
        this.commonsSessionStorageService.set('actualStepFlow', 'ibpurc');
        this.commonsSessionStorageService.set(GiftCardsAppConstant.SESSION_STORAGE.IS_NEW_PAYMENT, true);
        await this.initPayment();
        this.giftCardsDatalayerService.updateDigitalDataWithQuadrigam(GiftCardsAppConstant.QUADRIGAMS.GIFTCARDS_PAYMENT);
    }



    private showWaitingModal = () => {
        this.commonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true, null);
    };

    private closeWaitingModal = () => {
        this.commonsModalService.finishWaiting();
        this.commonsModalService.closeAllCurrentModals();
    };

    private stateChangeStatusActions = {
        LOADING: this.showWaitingModal.bind(this),
        LOADED: this.closeWaitingModal.bind(this),
        PRICE: async (data) => {
            // const newProps = await this.giftCardsPaymentService.getUpdatedPropsSummary(data['price'], data['fee']);
            // this.updatePropsSummary(newProps);
        }
    };

    stateChange = async (status: string, data: any) => {
        this.stateChangeStatusActions?.[status]?.(data);
    };


    private async initPayment (): Promise<void> {
        try {
            const response = await this.giftCardsPaymentService.init();
            const redirectionAfterNewPayment: any = this.commonsSessionStorageService.get('pmtRedirectContext');
            this.contextId = redirectionAfterNewPayment ? redirectionAfterNewPayment : response.paymentContext;
            this.paymentComponent = await this.IbGiftCardsPaymentsService.getNewPaymentComponent({
                contextId: this.contextId,
                onPaymentFailure: this.paymentFailure,
                onPaymentSuccess: this.paymentOk,
                target: document.querySelector('#pmt-container'),
                auth: { token: this.commonsSessionStorageService.get('anonymousToken') }
            });
            this.commonsSessionStorageService.set('pmtRedirectContext', response.paymentContext);


            // this.currency = this.commonsSessionStorageService.get<Types.ConfigurationModel>(GiftCardsAppConstant.SESSION_STORAGE.CONFIGURATION_INFO).importInfo.currency;
            this.updatePropsSummary(response.summaryPros);
            this.closeWaitingModal();
        } catch (error) {
            this.closeWaitingModal();
            this.commonsModalService.showGenericError(error, true, null).result.then(() => {
                this.redirectionLandingService.redirection(GiftCardsAppConstant.market.toLowerCase(), GiftCardsAppConstant.lang.toUpperCase());
            });
        }
    }

    private updatePropsSummary = (props: SummaryProps) => {
        this.summaryComponent.props = props;
        this.localStorageService.set(GiftCardsAppConstant.SESSION_STORAGE.SUMMARY, props, 'localStorage');
        this.showComponent = true;
    };

    paymentOk = () => {
        this.commonsSessionStorageService.remove('pmtRedirectContext');
        window.location.hash = '#!' + GiftCardRouterConstants.PAGES_URL.GIFTCARD_NEW_CONFIRMATION;
    };

    paymentFailure = () => {
        window.location.href = window.location.origin;
    };
}

downgradeToAJSComponent('ibGcPaymentsComponent', {
    component: IbGiftCardsPaymentsComponent,
    inputs: []
}, 'ib-gift-cards-payments');
